import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setK3Agents } from '../../actions/k3agentAction';
import {
  Modal,
  Form,
  Button,
  Row,
  Col,
  InputGroup
} from 'react-bootstrap';

class K3AgentCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      main_type: 'ai',
      sub_type: '',
      name: '',
      description: '',
      tags: '',
      status: 'active',
      availability: true,
      supported_task_types: '',
      metadata: '{}'
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const agentData = {
        ...this.state,
        tags: this.state.tags.split(',').map(tag => tag.trim()).filter(Boolean),
        supported_task_types: this.state.supported_task_types.split(',').map(type => type.trim()).filter(Boolean),
        metadata: JSON.parse(this.state.metadata)
      };
      await this.props.setK3Agents([agentData]);
      this.props.onHide();
    } catch (error) {
      console.error('Error creating agent:', error);
    }
  };

  render() {
    const { show, onHide } = this.props;
    const {
      main_type,
      sub_type,
      name,
      description,
      tags,
      status,
      availability,
      supported_task_types,
      metadata
    } = this.state;

    return (
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New Agent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Main Type</Form.Label>
                  <Form.Select
                    name="main_type"
                    value={main_type}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="HUMAN">Human</option>
                    <option value="AI">AI</option>
                    <option value="MACHINE">Machine</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Sub Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="sub_type"
                    value={sub_type}
                    onChange={this.handleChange}
                    required
                    placeholder="e.g. ChatGPT, Claude, etc."
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={name}
                    onChange={this.handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    type="text"
                    name="status"
                    value={status}
                    onChange={this.handleChange}
                    placeholder="e.g. active, inactive, maintenance"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                value={description}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Availability</Form.Label>
                  <Form.Select
                    name="availability"
                    value={availability}
                    onChange={this.handleChange}
                  >
                    <option value={true}>Available</option>
                    <option value={false}>Unavailable</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Tags (comma-separated)</Form.Label>
              <Form.Control
                type="text"
                name="tags"
                value={tags}
                onChange={this.handleChange}
                placeholder="tag1, tag2, tag3"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Supported Task Types (comma-separated)</Form.Label>
              <Form.Control
                type="text"
                name="supported_task_types"
                value={supported_task_types}
                onChange={this.handleChange}
                placeholder="type1, type2, type3"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Metadata (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                name="metadata"
                value={metadata}
                onChange={this.handleChange}
                rows={3}
                placeholder='{"key": "value"}'
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSubmit}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(null, { setK3Agents })(K3AgentCreator); 